export {
  default 
} from "./shippingInfo";
